import React, { useState, useEffect } from 'react';
import SelectField from './SelectField';
import { FaTimes, FaUserTag } from 'react-icons/fa';
import Modal from './Modal';

const RoleModal = ({ open, onClose, onSubmit, username }) => {
  const [role, setRole] = useState('');

  // Reset on open so a role picked for one user never persists into a later
  // open for a different user.
  useEffect(() => {
    if (open) setRole('');
  }, [open]);

  return (
    <Modal open={open} onClose={onClose} title={`Set Role for ${username}`}> 
      <div className="space-y-4">
        <SelectField
          className="input-field"
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value="">Select role</option>
          <option value="super-admin">Super-Admin</option>
          <option value="admin">Admin</option>
          <option value="qa">QA-Agent</option>
          <option value="call-agent">Call-Agent</option>
        </SelectField>
        <div className="flex flex-wrap justify-end gap-2 pt-2">
          <button onClick={onClose} className="btn-outline"><FaTimes />{' '}Cancel</button>
          <button onClick={() => role && onSubmit(role)} disabled={!role} className="btn-primary disabled:opacity-50"><FaUserTag />{' '}Set Role</button>
        </div>
      </div>
    </Modal>
  );
};

export default RoleModal;
